// dependencies
import { Map } from "immutable";

// redux
import { createStore, applyMiddleware, compose } from "redux";

// reducers
import createRootReducer from "../Reducers";

// middlewares
import Thunk from "../Middleware/Thunk";
import Logger from "../Middleware/Logger";
import PageTitle from "../Middleware/PageTitle";
import { ProcessMiddleware } from "redux-process";
import ErrorResponse from "../Middleware/ErrorResponse";
import RequestTracker from "../Middleware/RequestTracker";

// import processes
import processes from "Processes";
import request, { processConfig } from "Processes/request";

const buildStore = (initialState = Map()) => {
	const middleware = [
		Thunk,
		ProcessMiddleware(processes, request, processConfig),
		RequestTracker,
		ErrorResponse,
		PageTitle,
		Logger,
	];

	const store = createStore(createRootReducer(), initialState, compose(applyMiddleware(...middleware)));

	window.__store__ = store; // eslint-disable-line no-underscore-dangle

	return store;
};

export default buildStore;
